import React from 'react'
import './card-default.css'

const CardDefault = props => {
    return (
        <div className="card-default">
            <span>{props.data.label} {props.data.children ? (<small style={props.data.red ? { color: 'red' } : null}>{props.data.children.label}</small>) : null}</span>
            <div className="container-card-default">

                <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
                    <span style={props.data.red ? { color: 'red' } : null} className='txt-color value-card-default'>{props.data.value}</span>
                    {props.data.percent ? (
                        <div style={{width: '100px'}}>
                            <small className="precent-card-default"><i className="fas fa-long-arrow-alt-down"></i>{props.data.percent}</small>
                        </div>

                    ) : null}
                </div>

                <div style={{ width: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {props.data.children ? (
                        <span style={props.data.red ? { color: 'red' } : null} className='txt-color value-card-default'>{props.data.children.value}</span>
                    ) : (
                            <div className={props.data.img} style={{marginLeft: '10px'}}></div>

                        )}
                </div>
            </div>

        </div>
    )
}

export default CardDefault